import {Grid, Typography} from '@mui/material'
import Button from '@mui/material/Button'
import {Link, useNavigate} from 'react-router-dom'
import {useAuth} from '../components/auth/AuthProvider'
import MyDecks from './MyDecks'
import LimitedPublicDecks from '../components/LimitedPublicDecks'
import LoadingBackdrop from '../components/LoadingBackdrop'
import {useState} from 'react'
import Box from '@mui/material/Box'

export default function Home() {
  const navigate = useNavigate()
  const {user} = useAuth()
  const isAnon = user === null
  const [loading, setLoading] = useState<boolean>(false)
  
  const handleAddPublicDeck = () => {
    setLoading(true)
    navigate('/redirect/home')
  }

  return (
    <>
      <LoadingBackdrop loading={loading}/>
      {isAnon && <AnonHome onAddPublicDeck={handleAddPublicDeck}/>}
      {!isAnon && <SignedInHome onAddPublicDeck={handleAddPublicDeck}/>}
    </>
  )
}

function AnonHome({onAddPublicDeck}: {onAddPublicDeck: VoidFunction}) {
  return (
    <>
      <Grid container  sx={{my: 2, flexDirection: {xs: 'column-reverse',  md:'row'}}}>

        <Grid item xs={12} md={4}>
          <Box sx={{maxWidth: '350px'}}>
            <video muted autoPlay loop playsInline width="100%">
              <source src="/images/planets-demo.mp4"/>
            </video>  
          </Box>
        </Grid>

        <Grid item xs={12} md={7} >
          <Typography variant="h1">
            Flashcards
          </Typography>
          <Typography variant="h2">
            Study anything, anytime, anywhere
          </Typography>
          <Grid container sx={{my: 3}}>
            <Grid item xs={12} sm={6} sx={{pr: {xs: 0, sm: 2}, py: {xs: 2, sm: 0}}}>
          <Link to="/sign-up" style={{textDecoration: "none", color: "inherit"}}>
            <Button
              variant="contained"
              fullWidth
              color="success"
              sx={{
                
                fontSize: '20px',
                fontWeight: 900,
                textTransform: 'none',
                display: "flex",
                alignItems: "center",
              }}>Sign up for Free!</Button>
            
          </Link>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Link to="/login" style={{textDecoration: "none", color: "inherit"}}>
                <Button
                  variant="contained"
                  fullWidth
                  color="success"
                  sx={{
                 
                    fontSize: '20px',
                    fontWeight: 900,
                    textTransform: 'none',
                    display: "flex",
                    alignItems: "center",
                  }}>Login</Button>

              </Link>
            </Grid>
          </Grid>
          <Typography gutterBottom variant="h5">
            How to Study
          </Typography>
          <Typography gutterBottom variant="h6">
            1. Look at a card. When you're ready, click "show answer".
          </Typography>
          <Typography gutterBottom variant="h6">
            2. Click "got it" or "not yet". 
          </Typography>
          <Typography gutterBottom variant="h6">
          3. View results of your study session and adjust which cards will remain visible for your next study session.
          </Typography>
        </Grid>
      </Grid>
      <Grid container>

        <Grid item xs={12}>
          <LimitedPublicDecks isAnon onAddPublicDeck={onAddPublicDeck}/>
        </Grid>
      </Grid>
    </>
  )
}

function SignedInHome({onAddPublicDeck}: {onAddPublicDeck: VoidFunction}) {
  return (
    <>
      <MyDecks hidePublicDecksLink/>
      <br/>
      <LimitedPublicDecks isAnon={false} onAddPublicDeck={onAddPublicDeck}/>
    </>
  )
}
